import React from "react";
import { Box, Button } from "@mui/material";
import { CountryCode, COUNTRIES } from "../mockData/marketplaceMockData";

interface Props {
  activeCountry: CountryCode;
  onChange: (country: CountryCode) => void;
  variant?: "default" | "hero";
}

const CountryTabs: React.FC<Props> = ({ activeCountry, onChange, variant = "default" }) => {
  return (
    <Box className={`marketplace_country_tabs ${variant === "hero" ? "hero_variant" : ""}`}>
      {COUNTRIES.map((country) => (
        <Button
          key={country.code}
          className={activeCountry === country.code ? "country_tab active" : "country_tab"}
          onClick={() => onChange(country.code)}
        >
          <span className="flag">{country.flag}</span>
          {country.label}
        </Button>
      ))}
    </Box>
  );
};

export default CountryTabs;
